import React from 'react'

export const Divider = ({ color }) => <svg xmlns="http://www.w3.org/2000/svg" width="1155" height="1.5" viewBox="0 0 1155 1.5">
    <line id="Line_2" data-name="Line 2" x2="1155" transform="translate(0 0.75)" fill="none" stroke="#707070" strokeWidth="0.25" />
    <line id="Line_3" data-name="Line 3" x2="314" transform="translate(45 0.75)" fill="none" stroke={color} strokeWidth="1.5" />
</svg>
